module.exports = __webpack_public_path__ + "static/media/secure-pin-icon.ce9b38b9.svg";